<app-top-navigation></app-top-navigation>

<section class="home-bg relative text-left">
    <div class="container">
        <div class="centered-element">
           <div class="row">
            <div class="medium-12 columns">
                <div class="mega-text margin-bottom-05 uppercase gotham">
                   Store Location
                </div>
                <div class="huge-text gotham thin-font">
                   Lihat langsung berbagai produk DJI dengan pengalaman belanja yang luar biasa
                </div>
            </div>
           </div>
        </div>
    </div>
</section>

<div class="padding-center">
    <div class="row">
        <div class="medium-6 columns gotham black-color">
            <div class="large-text">
                DEALER RESMI DJI INDONESIA
                </div>
            <div class="mega-text">
             DJI Channel
            </div>
            <div class="large-text margin-bottom-1">
                Rukan Batavia PIK,<br>
                Rukan Beach View Blok C no.6<br>
                Golf Island, Pantai Indah Kapuk<br>
                Kel. Kamal Muara Kec. Penjaringan,<br>
                DKI Jakarta 14470
            </div>
            <div class="small-text">
                Phone
            </div>
            <div class="large-text margin-bottom-1">
               <fa-icon [icon]="faPhone"></fa-icon> +6281533178887
            </div>

            <div class="small-text">
                Email
            </div>
            <div class="large-text margin-bottom-2">
                <fa-icon [icon]="faEnvelope"></fa-icon> dji&#64;deltajagatindonesia.com
             </div>
        </div>
        <div class="medium-6 columns">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3965.969734250816!2d106.78114817517273!3d-6.267710861359365!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f1a5e4b94513%3A0x85afe10e92218aa7!2sDJI%20Pondok%20Indah%20Mall!5e0!3m2!1sen!2sid!4v1726044989757!5m2!1sen!2sid"  style="border:0;width: 100%; height: 300px;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
    </div>
</div>

<app-section-gallery></app-section-gallery>


<app-section-footer></app-section-footer>